import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { APP_TEXT_EN, APP_TEXT_ES, THEMEDATA } from '../../../shared/constants/app.constants';
import { GlobalService } from '../../../shared/services/global.service';
import { UtilService } from 'src/app/shared/services/utils.service';
import { SharedDataService } from 'src/app/shared/services/registration.service';
import { event, Events } from 'src/app/shared/model/common.model';

@Component({
  selector: 'app-info-section',
  templateUrl: './info-section.component.html',
  styleUrls: ['./info-section.component.scss']
})
export class InfoSectionComponent implements OnInit {

  public language : string = 'EN';
  public textConstants: any = this.language === 'EN' ? APP_TEXT_EN : APP_TEXT_ES;

  public mainImageURL: string = '../../../assets/img/info-default.webp';
  public title!: string;
  public ctaButtonText: string = this.textConstants.INFO.CTA_BUTTON_TEXT;
  public eventCount: number = 0;
  langDictionary:any;
  bulletsFirst:boolean = false 
  showSection!:boolean

  public bulletPoints!: string[];
  public paraPoints!: string[];
  public defaultBulletPoints!: string[];
  // [
  //     'How to maximize Social Security retirement or pension benefits',
  //     'Implications of the new tax reform rules on your retirement plan',
  //     'Tools and strategies to help you avoid outliving your nest egg',
  //     'Strategies for generating steady income during your retirement',
  //     'Taxes, fees and other potentially hidden costs of pulling money out of 401k and/or mutual fund accounts',
  //     'Ways to overcome mental and financial obstacles that most people face in retirement'
  // ];
  infoimageurl!:string;
  ctaDisabled:boolean = false;
  eventList:event[] = [];
  sectionImageUrl: any;
  constructor(private sharedDataService: SharedDataService, private scrollService: UtilService, private globalService: GlobalService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    let eventListFlag:boolean=false;
    this.sharedDataService.ctaDisableData.subscribe(data=>{
      this.ctaDisabled = data;
    })
    this.langDictionary = this.globalService.Language;  
    this.defaultBulletPoints = this.langDictionary.INFO.DEFAULT_BULLETS;
    this.globalService.jobInformation.subscribe((data) => {
      this.showSection = (data?.pageData?.sectionContent?.hideSection)?false:true;
      this.bulletsFirst = data?.pageData?.sectionContent?.bulletsFirst;
      this.title = data?.pageData?.sectionContent?.title || this.langDictionary.INFO.TITLE;
      this.sectionImageUrl=data?.pageData?.sectionContent.imageMainURL;
      this.mainImageURL = this.sectionImageUrl || data.jobInfo.CampaignInfo.EventImage || this.mainImageURL;
      this.eventCount = data.eventCount || 0;
      if (this.eventCount < 2) {
        this.ctaButtonText = data?.pageData?.sectionContent?.ctaButtonSelectEvent || this.langDictionary.INFO.CTA_BUTTON_TEXT_SINGLE;
      }else{
        this.ctaButtonText = data?.pageData?.sectionContent?.ctaButtonSelectEvent || this.langDictionary.INFO.CTA_BUTTON_TEXT;
      }
      this.bulletPoints = (data?.pageData?.sectionContent?.contentBullets && data?.pageData?.sectionContent?.contentBullets.length > 0)? data?.pageData?.sectionContent?.contentBullets : [];
      this.paraPoints = (data?.pageData?.sectionContent?.contentText && data?.pageData?.sectionContent?.contentText.length > 0)? data?.pageData?.sectionContent?.contentText : [];
      data?.pageData?.sectionEvents?.events?.forEach((item: any) => {
        const eventItem: event = {
          title: item?.title,
          paragraphs: Array.isArray(item?.paragraphs) ? item.paragraphs : [],
          bullets: Array.isArray(item?.bullets) ? item.bullets : []
        };
        this.eventList.push(eventItem)
        if ((eventItem.title == null || eventItem.title == '') || eventItem?.paragraphs.length == 0 && eventItem?.bullets.length == 0) {
          eventListFlag = true;
        }
      })
      this.eventList = (eventListFlag)?[]:this.eventList;
    });

    
    
   
  }
  ngAfterViewInit(){

    this.scrollService.theme$.subscribe(img => {
      // const themelist = THEMEDATA;
      // const newTheme = themelist.find(item => item.themeId.trim().toUpperCase() === theme.trim().toUpperCase());
      if (img) {
        const strimage = img;
        const infoImgElement = document.querySelector('.infoimage') as HTMLElement;
        if (infoImgElement) {
          this.mainImageURL = `../../../../assets/img/${strimage}`
          this.cdr.detectChanges();
        }
      }

    })
  }
  register() {
    if(this.globalService.eventCount == 1){
      this.scrollService.triggerScroll('scrollToRegister');
    } else if(this.globalService.eventCount > 1){
      this.scrollService.triggerScroll('scrollToEvents');
    }
  }
}
